import * as React from 'react'

import { Button, LazyToggleMethod } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { getFeatureParams } from 'modules/shift_management/lib/getFeatureParams'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  feature:
    | Features.shift_management_coverage_view
    | Features.shift_management_insights_panel
    | Features.shift_management_view_options
  setIsTooltipOpen?: LazyToggleMethod
  disabled?: boolean
}

const UpgradeButton = ({ feature, setIsTooltipOpen, disabled = false }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const { company } = useCurrentSession()
  const currentSubscription = company.subscription
  const requestReason = currentSubscription.isLegacy
    ? ValidReasons.MissingFeatureLegacy
    : ValidReasons.MissingFeature

  const featureParams = getFeatureParams({ feature })
  const { iconName, from } = featureParams

  const onClick = () => {
    track(trackingEvents.shiftManagement.requestPlanUpdate, {
      from: from,
    })

    setIsModalOpen(true)
  }

  const onClose = () => {
    if (setIsTooltipOpen) setIsTooltipOpen(false)()
    setIsModalOpen(false)
  }

  return (
    <>
      <Button type="secondary" onClick={onClick} iconName={iconName} disabled={disabled} />
      {isModalOpen && (
        <RequestUpgradeModal
          moduleRequested={AvailableModules.shift_management}
          featureRequested={feature}
          requestSource={from}
          requestReason={requestReason}
          onClose={onClose}
        />
      )}
    </>
  )
}

export default UpgradeButton
